import {useParams, useNavigate} from "react-router-dom";
import {RU, EN, PL, UA} from './privacyPolicies'

const textStyle = {
    whiteSpace: 'pre-line',
    fontSize: 20
}

export const PrivacyPolicy = (props) => {
    let {lang} = useParams()
    let go = useNavigate()

    if (!lang)
        lang = 'en'

    const text = {'ru': RU, 'en': EN, 'pl': PL, 'ua': UA}[lang.toLowerCase()]

    return <div style={{'padding': '30px', maxWidth: '900px', width: '100%', margin: 'auto',}}>
        <div>
            <label style={{fontSize: 22}}>Language: </label>
            <select style={{fontSize: 22}} onChange={x => go('/privacy/' + x.target.value)} defaultValue={lang}>
                <option value={'en'}>English</option>
                <option value={'pl'}>Polish</option>
                <option value={'ua'}>Ukrainian</option>
            </select>
        </div>
        <div style={{padding: '30px 10px'}}>
            <p style={textStyle}> {text}</p>
        </div>
    </div>

}




export const DeletionPolicy = (props) => {
    return <>
        <div style={{'padding': '30px', maxWidth: '900px', width: '100%', margin: 'auto',}}>
            <div style={{padding: '30px 10px'}}>
                <p style={textStyle}>{`
 🔸 Account Deletion
 
                    You have the right to request deletion of your Greenbin account and all associated data at any time.

                    You can do so in two ways:

                    From within the app:
                    Go to Profile → Delete Account to remove your account and related personal data permanently.

                    Via our online form:
                    Submit a request through our official deletion form:
                    👉 `}<a href={'https://forms.gle/1aYZGtXnTwDGEafk8'}>https://forms.gle/1aYZGtXnTwDGEafk8</a>{`
                    
                    Your request will be processed within 7 business days.
                    If law or regulation requires, some data may be retained for fraud prevention or legal compliance purposes.`}</p>
            </div>
        </div>
    </>
}